template = require('./bank_codes.html.slim')

angular.module('wbComponents').directive 'wbBankCodes', ['$timeout', ($timeout) ->
  scope:
    model: '='
    disabled: '='
  restrict: 'E'
  replace: true
  require: '?ngModel'
  templateUrl: template
  link: (scope, el, attrs, ngModel) ->
    scope.name = attrs['name']
    scope.banks = [
      { code: '001', name: 'Bank of Montreal'},
      { code: '002', name: 'Bank of Nova Scotia'},
      { code: '003', name: 'Royal Bank of Canada'},
      { code: '004', name: 'Toronto-Dominion Bank'},
      { code: '004', name: 'TD Canada Trust'},
      { code: '006', name: 'National Bank of Canada'},
      { code: '010', name: 'Canadian Imperial Bank of Commerce'},
      { code: '010', name: "President's Choice Financial"},
      { code: '016', name: 'HSBC Canada'},
      { code: '030', name: 'Canadian Western Bank'},
      { code: '039', name: 'Laurentian Bank of Canada'},
      { code: '117', name: 'Government of Canada'},
      { code: '127', name: 'Canada Post'},
      { code: '177', name: 'Bank of Canada'},
      { code: '219', name: 'ATB Financial'},
      { code: '241', name: 'Bank of America Canada'},
      { code: '245', name: 'The Bank of Tokyo-Mitsubishi UFJ (Canada)'},
      { code: '250', name: 'BNP Paribas (Canada)'},
      { code: '260', name: 'Citibank Canada'},
      { code: '269', name: 'Mega International Commercial Bank Canada'},
      { code: '270', name: 'JPMorgan Chase Bank, N.A. (Toronto Branch)'},
      { code: '275', name: 'Korea Exchange Bank of Canada'},
      { code: '290', name: 'UBS Bank (Canada)'},
      { code: '294', name: 'State Bank of India (Canada)'},
      { code: '307', name: 'Industrial and Commercial Bank of China (Canada)'},
      { code: '308', name: 'Bank of China (Canada)'},
      { code: '309', name: 'Citizens Bank of Canada (Canada)'},
      { code: '315', name: 'CTC Bank of Canada'},
      { code: '332', name: 'First Commercial Bank'},
      { code: '338', name: 'Canadian Tire Bank'},
      { code: '340', name: 'ICICI Bank Canada'},
      { code: '355', name: 'SHINHAN Bank Canada'},
      { code: '540', name: 'Manulife Bank'},
      { code: '614', name: 'Tangerine Bank (formerly ING Direct Canada)'},
      { code: '809', name: '[Central 1 [Credit Union] - BC Region]'},
      { code: '815', name: 'Caisses Desjardins du Québec'},
      { code: '819', name: 'Caisses populaires Desjardins du Manitoba'},
      { code: '828', name: '[Central 1 [Credit Union] - ON Region]'},
      { code: '829', name: "Caisses populaires Desjardins de l'Ontario"},
      { code: '837', name: 'Meridian Credit Union (formerly Hepco)'},
      { code: '839', name: 'Credit Union Heritage (Nova Scotia)'},
      { code: '865', name: 'Caisses populaires Desjardins acadiennes'},
      { code: '879', name: 'Credit Union Central of Manitoba'},
      { code: '889', name: 'Credit Union Central of Saskatchewan'},
      { code: '899', name: 'Credit Union Central Alberta'}
    ]

    scope.handleSelection = (selectedItem) ->
      scope.model = selectedItem.code
      scope.current = 0
      scope.selected = true

    scope.current = 0
    scope.selected = true
    scope.isCurrent = (index) ->
      scope.current == index
    scope.setCurrent = (index) ->
      scope.current = index
]
